export default {
  entered: 'ENTERED',
  beingprepared: 'BEINGPREPARED',
  readyforpickup: 'READYFORPICKUP',
};
